import Config from "@/const/Config";
import { CheckListReq, CheckListRes, SyainCsvReq } from "@/types/Px";
import { BaseApi } from "./BaseApi";

export class PxApi extends BaseApi {

  /**
  * 勤怠CSVダウンロードをします
  * @param params
  * @returns
  */
  public async downloadKintaiCSV(start:string, end:string): Promise<any> {
    try {
      return await this.get(Config.API_URL + `/px/kintaicsv`, {
        responseType: "blob",
        start: start,
        end: end
      });
    } catch (e: any) {
      throw e;
    }
  }

  /**
  * 社員情報CSVダウンロードをします
  * @param params
  * @returns
  */
  public async downloadSyainCSV(req: SyainCsvReq) {
    try {
      return await this.get(Config.API_URL + `/px/syaincsv`, {
        responseType: "blob",
        userId: req.userId,
        koyouKeiyakuId: req.koyouKeiyakuId
      });
    } catch (e: any) {
      throw e;
    }
  }

  // 勤務承認の確定状況をを取得
  public async getKinmuStatusForPx(req: CheckListReq):Promise<CheckListRes> {
    try {
      const res = await this.post<CheckListRes>(Config.API_URL + `/px/check_kinmu_status`, req);
      return res.data
    } catch (e: any) {
      console.log(e)
      throw e;
    }
  }
}
